import { render, staticRenderFns } from "./new_holiday.vue?vue&type=template&id=0b2747ca&scoped=true"
import script from "./new_holiday.vue?vue&type=script&lang=js"
export * from "./new_holiday.vue?vue&type=script&lang=js"
import style0 from "./new_holiday.vue?vue&type=style&index=0&id=0b2747ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2747ca",
  null
  
)

export default component.exports